import { render, staticRenderFns } from "./FuerzaPage.vue?vue&type=template&id=58937be6"
import script from "./FuerzaPage.js?vue&type=script&lang=js&external"
export * from "./FuerzaPage.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports